import React, { useRef } from "react";
import "./service.css";
import star1 from "../Assets/services/star1.png";
import star2 from "../Assets/services/star2.png";
import cowork from "../Assets/services/coworkingImg.png";
import androidDevImg from "../Assets/whatWeOffer/androidDev.png";
import cloudDevImg from "../Assets/whatWeOffer/cloudDev.png";
import webDevImg from "../Assets/whatWeOffer/webDev.png";
import iotImg from "../Assets/services/iotInt.png";
import softImg from "../Assets/services/softImg.png";
import uiuxImg from "../Assets/services/uiUx.png";
import advn1 from "../Assets/services/advance1.png";
import advn2 from "../Assets/services/advance2.png";
import advn3 from "../Assets/services/advance3.png";
import advn4 from "../Assets/services/advance4.png";
import advn5 from "../Assets/services/advance5.png";
import advn6 from "../Assets/services/advance6.png";

function Services() {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    const container = card.parentElement;
    const rect = container.getBoundingClientRect();

    // Calculate position relative to container center
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const xPos = (rect.width / 2 - x) / 10;
    const yPos = (rect.height / 2 - y) / 10;

    card.style.transform = `rotateX(${yPos}deg) rotateY(${xPos}deg)`;
  };

  const handleMouseEnter = () => {
    cardRef.current.style.transition = "none";
  };

  const handleMouseLeave = () => {
    cardRef.current.style.transition = "transform 0.3s";
    cardRef.current.style.transform = "none";
  };

  return (
    <div className="service-main-container">
      <div className="service-main-inner">
        <h1 className="services-main-heading font-cardo">
          What <span>Services we offering</span>
          <span className="star1">
            <img src={star1} alt="star1" width={"40px "} />
          </span>
          <span className="star2">
            <img src={star2} alt="star2" width={"30px"} />
          </span>
          <span className="star3">
            <img src={star1} alt="star3" width={"30px "} />
          </span>
          <span className="star4">
            <img src={star1} alt="star4" width={"22px "} />
          </span>
        </h1>
        <div className="mt-5 font-inter inter-para text-center">
          We <span>craft high-impact</span> digital solutions backed by{" "}
          <span>smart strategy, intuitive design</span>, and{" "}
          <span>cutting-edge tech.</span>
          <div>Everything we build is designed to grow with your business.</div>
        </div>
        <span className="cowork-img">
          <img src={cowork} alt="img" width={"300px"} />
        </span>
      </div>
      <div className="service-container">
        <div
          className=""
          style={{ borderLeft: "1px solid #0000007D", paddingBottom: "50px" }}
        >
          <div className="row m-0">
            <div className="col col-12 col-md-6 col-lg-6 ps-0 pe-0 pe-xl-4 pe-lg-4">
              <div className="row m-0">
                <div className="col-12">
                  <div className="offer-box">
                    <div className="card">
                      <img
                        src={webDevImg}
                        className="card-img-top"
                        alt="Web App Developer"
                      />
                      <div className="card-body">
                        <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                          Web App Development
                        </h4>
                        <p className="card-text text-start font-inter inter-para">
                          We build secure, responsive, and modern web
                          applications tailored to your workflows and business
                          goals.
                        </p>
                        <div className="card-text font-inter inter-para">
                          <span>What you get</span>
                          <ul>
                            <li>
                              Full-stack development (React, Node.js, Python,
                              etc.){" "}
                            </li>
                            <li>Clean UI with intuitive navigation</li>
                            <li>Scalable architecture for future growth</li>
                          </ul>
                          <span>USP</span>
                          <div>
                            From MVPs to enterprise-grade systems, we deliver
                            web apps that drive real business value.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="offer-box mb-0">
                    <div className="card">
                      <img
                        src={androidDevImg}
                        className="card-img-top"
                        alt="Web App Developer"
                      />
                      <div className="card-body">
                        <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                          Android Development
                        </h4>
                        <p className="card-text text-start font-inter inter-para">
                          We design and develop custom Android apps using both
                          native and cross-platform technologies (Kotlin,
                          Flutter, React Native).
                        </p>
                        <div className="card-text font-inter inter-para">
                          <span>What you get</span>
                          <ul>
                            <li>Seamless user experience</li>
                            <li>Fast, responsive performance</li>
                            <li>Compatibility across Android devices</li>
                          </ul>
                          <span>USP</span>
                          <div>
                            We ensure your app isn't just functional, but
                            market-ready and user-loved.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col col-12 col-md-6 col-lg-6 pe-0 ps-0 ps-xl-4 ps-lg-4"
              style={{ marginTop: "170px" }}
            >
              <div className="row m-0 right-row">
                <div className="col-12">
                  <div className="offer-box">
                    <div className="card">
                      <img
                        src={cloudDevImg}
                        className="card-img-top"
                        alt="Web App Developer"
                      />
                      <div className="card-body">
                        <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                          Cloud Development
                        </h4>
                        <p className="card-text text-start font-inter inter-para">
                          Our cloud-first approach helps businesses stay agile,
                          scalable, and cost-effective.
                        </p>
                        <div className="card-text font-inter inter-para">
                          <span>What you get</span>
                          <ul>
                            <li>Serverless architectures</li>
                            <li>Cloud migration & setup (AWS, Azure, GCP)</li>
                            <li>Scalable infrastructure & CI/CD</li>
                          </ul>
                          <span>USP</span>
                          <div>
                            We design systems that grow with you, with full
                            security and high availability.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="offer-box mb-0">
                    <div className="card">
                      <img
                        src={iotImg}
                        className="card-img-top"
                        alt="IoT Integration"
                      />
                      <div className="card-body">
                        <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                          IoT Integration
                        </h4>
                        <p className="card-text text-start font-inter inter-para">
                          From smart home devices to industrial sensors, we
                          build intelligent IoT solutions that connect, monitor,
                          and automate.{" "}
                        </p>
                        <div className="card-text font-inter inter-para">
                          <span>What you get</span>
                          <ul>
                            <li>Device-to-cloud data flow</li>
                            <li>Real-time analytics & control</li>
                            <li>Secure integration & firmware updates</li>
                          </ul>
                          <span>USP</span>
                          <div>
                            We combine hardware understanding with software
                            excellence to deliver truly smart environments.{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hr-grey hr-grey2"></div>
        <div className="service2">
          <div className="row m-0">
            <div className="col col-12 p-0">
              <div className="service-boxx">
                <div className="card">
                  <img src={softImg} className="card-img-top" alt="software" />
                  <div className="card-body">
                    <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                      IoT Integration
                    </h4>
                    <p className="card-text text-start font-inter inter-para">
                      Software tailored exactly to your business logic,
                      operations, and growth trajectory.
                    </p>
                    <div className="card-text font-inter inter-para">
                      <span>What you get</span>
                      <ul>
                        <li>Business-specific functionality</li>
                        <li>Scalable, maintainable codebase</li>
                        <li>Integration with existing tools</li>
                      </ul>
                      <span>USP</span>
                      <div>
                        We don’t just write code—we solve your business
                        challenges with software.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col col-12 p-0">
              <div className="service-boxx mt-5">
                <div className="card">
                  <img src={uiuxImg} className="card-img-top" alt="software" />
                  <div className="card-body">
                    <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                      UI/UX Design
                    </h4>
                    <p className="card-text text-start font-inter inter-para">
                      Beautiful and usable design is at the heart of every
                      product we build.
                    </p>
                    <div className="card-text font-inter inter-para">
                      <span>What you get</span>
                      <ul>
                        <li>Wireframes, prototypes, and final UI</li>
                        <li>Design systems for consistent branding</li>
                        <li>Accessibility & responsiveness</li>
                      </ul>
                      <span>USP</span>
                      <div>
                        We design for the people using your product—not just for
                        pixels.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="service3">
          <h1
            className="font-cardo fw-bold text-start"
            style={{ color: "rgba(78, 70, 94, 1)" }}
          >
            Advanced Solutions
          </h1>
          <div className="advance-main">
            <div className="advance-container">
              <div className="adv-main-box">
                <div className="adv-box">
                  <div className="card">
                    <div className="row g-0 align-items-center">
                      <div className="col-xl-4 col-lg-4">
                        <div class="split-image-container advn-1">
                          <div class="advn advn1 advn-1"></div>
                          {/* <div class="advn advn1 advn-2"></div>
                          <div class="advn advn1 advn-3"></div>
                          <div class="advn advn1 advn-4"></div> */}
                        </div>
                      </div>
                      <div className="col-xl-8 col-lg-8 ps-4">
                        <div className="card-body">
                          <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                            Digital Transformation & Automation
                          </h4>
                          <p className="card-text text-start font-inter inter-para">
                            We modernize operations and automate processes using
                            intelligent software and integrations.
                          </p>
                          <div className="card-text font-inter inter-para">
                            <span>What you get</span>
                            <ul>
                              <li>Workflow automation</li>
                              <li>Legacy system upgrades</li>
                              <li>ERP/CRM modernization</li>
                            </ul>
                            <span>USP</span>
                            <div>
                              Get faster operations, lower manual workload, and
                              smarter business flow.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="adv-main-box">
                <div className="adv-box float-md-end float-lg-end">
                  <div className="card mb-3">
                    <div className="row g-0 align-items-center">
                      <div className="col-xl-8 col-lg-8 pe-4">
                        <div className="card-body">
                          <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                            Data Analytics & Visualization
                          </h4>
                          <p className="card-text text-start font-inter inter-para">
                            Turn your data into actionable insights with our
                            custom dashboards and data services.
                          </p>
                          <div className="card-text font-inter inter-para">
                            <span>What you get</span>
                            <ul>
                              <li>Data pipeline setup</li>
                              <li>
                                Real-time dashboards (Power BI, Tableau, custom)
                              </li>
                              <li>Business intelligence tools</li>
                            </ul>
                            <span>USP</span>
                            <div>
                              Make data-driven decisions without getting lost in
                              complexity.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4">
                        <div class="split-image-container">
                          <div class="advn advn2 advn-1"></div>
                          {/* <div class="advn advn2 advn-2"></div>
                          <div class="advn advn2 advn-3"></div>
                          <div class="advn advn2 advn-4"></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="adv-main-box">
                <div className="adv-box">
                  <div className="card">
                    <div className="row g-0 align-items-center">
                      <div className="col-xl-4 col-lg-4">
                        <div class="split-image-container">
                          <div class="advn advn3 advn-1"></div>
                          {/* <div class="advn advn3 advn-2"></div>
                          <div class="advn advn3 advn-3"></div>
                          <div class="advn advn3 advn-4"></div> */}
                        </div>
                      </div>
                      <div className="col-xl-8 col-lg-8 ps-4">
                        <div className="card-body">
                          <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                            AI & Machine Learning
                          </h4>
                          <p className="card-text text-start font-inter inter-para">
                            We modernize operations and automate processes using
                            intelligent software and integrations.
                          </p>
                          <div className="card-text font-inter inter-para">
                            <span>What you get</span>
                            <ul>
                              <li>ML model development & deployment</li>
                              <li>Natural language processing (NLP)</li>
                              <li>Recommendation engines</li>
                            </ul>
                            <span>USP</span>
                            <div>
                              We apply AI where it actually improves user
                              experience or business results.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="adv-main-box">
                <div className="adv-box float-md-end float-lg-end">
                  <div className="card mb-3">
                    <div className="row g-0 align-items-center">
                      <div className="col-xl-8 col-lg-8 pe-4">
                        <div className="card-body">
                          <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                            API Development & Integration
                          </h4>
                          <p className="card-text text-start font-inter inter-para">
                            We build powerful APIs and ensure seamless
                            connectivity between platforms.
                          </p>
                          <div className="card-text font-inter inter-para">
                            <span>What you get</span>
                            <ul>
                              <li>REST/GraphQL APIs</li>
                              <li>3rd-party platform integrations</li>
                              <li>
                                Secure, scalable, and well-documented endpoints
                              </li>
                            </ul>
                            <span>USP</span>
                            <div>
                              Our APIs are designed for speed, security, and
                              longevity.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4">
                        <div class="split-image-container">
                          <div class="advn advn4 advn-1"></div>
                          {/* <div class="advn advn4 advn-2"></div>
                          <div class="advn advn4 advn-3"></div>
                          <div class="advn advn4 advn-4"></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="adv-main-box">
                <div className="adv-box">
                  <div className="card">
                    <div className="row g-0 align-items-center">
                      <div className="col-xl-4 col-lg-4">
                        <div class="split-image-container">
                          <div class="advn advn5 advn-1"></div>
                          {/* <div class="advn advn5 advn-2"></div>
                          <div class="advn advn5 advn-3"></div>
                          <div class="advn advn5 advn-4"></div> */}
                        </div>
                      </div>
                      <div className="col-xl-8 col-lg-8 ps-4">
                        <div className="card-body">
                          <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                            Maintenance & Support
                          </h4>
                          <p className="card-text text-start font-inter inter-para">
                            We keep your systems secure, updated, and optimized
                            long after launch.
                          </p>
                          <div className="card-text font-inter inter-para">
                            <span>What you get</span>
                            <ul>
                              <li>Bug fixes & security patches</li>
                              <li>Performance monitoring</li>
                              <li>Ongoing improvements & features</li>
                            </ul>
                            <span>USP</span>
                            <div>
                              We’re not a one-time vendor—we’re your long-term
                              technology partner..
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="adv-main-box">
                <div className="adv-box float-md-end float-lg-end">
                  <div className="card mb-3">
                    <div className="row g-0 align-items-center">
                      <div className="col-xl-8 col-lg-8 pe-4">
                        <div className="card-body">
                          <h4 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-3">
                            IT Consulting
                          </h4>
                          <p className="card-text text-start font-inter inter-para">
                            Smart, strategic advice to help align your tech
                            investments with your business goals.
                          </p>
                          <div className="card-text font-inter inter-para">
                            <span>What you get</span>
                            <ul>
                              <li>Product strategy & technology selection</li>
                              <li>Roadmaps & budget planning</li>
                              <li>MVP scoping and growth planning</li>
                            </ul>
                            <span>USP</span>
                            <div>
                              We combine deep tech knowledge with business logic
                              to guide you confidently forward.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4">
                        <div class="split-image-container">
                          <div class="advn advn6 advn-1"></div>
                          {/* <div class="advn advn6 advn-2"></div>
                          <div class="advn advn6 advn-3"></div>
                          <div class="advn advn6 advn-4"></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
